export async function validate(vatNumber) {
    const response = await fetch(`https://vat.bizzw.com/verify?number=${vatNumber}`);
    return response.json();
}